import IconButton, { IconButtonProps } from '@mui/material/IconButton';

export { IconButton, IconButtonProps };
